package com.sweetlime.dungeonamigo.presentation.ui.components

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.sweetlime.dungeonamigo.model.Character
import com.sweetlime.dungeonamigo.presentation.ui.theme.BrandColors
import com.sweetlime.dungeonamigo.presentation.ui.theme.silkFont
import com.sweetlime.dungeonamigo.util.AvatarMapper
import org.jetbrains.compose.resources.painterResource

/**
 * Rounded-square avatar tile with class-color tinted border and gradient background.
 * Renders pixel avatars with FilterQuality.None for crisp pixel-art scaling.
 */
@Composable
fun AvatarTile(
    character: Character,
    classColor: Color,
    size: Dp = 60.dp,
    modifier: Modifier = Modifier,
) {
    val sf = silkFont()
    val shape = RoundedCornerShape(8.dp)
    val avatarResource = if (character.avatarId.isNotBlank()) AvatarMapper.drawableFor(character.avatarId) else null

    Box(
        modifier = modifier
            .size(size)
            .clip(shape)
            .background(
                brush = Brush.verticalGradient(
                    listOf(classColor.copy(alpha = 0.18f), BrandColors.StoneLight)
                )
            )
            .border(2.dp, classColor.copy(alpha = 0.47f), shape),
        contentAlignment = Alignment.Center,
    ) {
        if (avatarResource != null) {
            Image(
                painter = painterResource(avatarResource),
                contentDescription = character.characterClass,
                modifier = Modifier.fillMaxSize(),
                contentScale = ContentScale.Fit,
            )
        } else {
            Text(
                text = character.characterClass.take(1).uppercase(),
                color = classColor,
                fontFamily = sf,
                fontSize = (size.value * 0.32f).sp,
                fontWeight = FontWeight.Bold,
            )
        }
    }
}
